import { render, staticRenderFns } from "./SayHelloToUs.vue?vue&type=template&id=248bd115&scoped=true&"
import script from "./SayHelloToUs.vue?vue&type=script&lang=js&"
export * from "./SayHelloToUs.vue?vue&type=script&lang=js&"
import style0 from "./SayHelloToUs.vue?vue&type=style&index=0&id=248bd115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248bd115",
  null
  
)

export default component.exports